var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TMObstacles'),_c('StepsInTM'),_c('ActionSteps'),_c('TMResources'),_c('StartReceive')],1)}
var staticRenderFns = []

export { render, staticRenderFns }